
import { useTheme } from '../../contexts/ThemeContext';

export default function EULA() {
  const { theme } = useTheme();
  
  return (
    <div className={`container mx-auto px-4 py-8 ${
      theme === 'dark' ? 'text-gray-300' : 'text-gray-700'
    }`}>
      <h1 className="text-3xl font-bold mb-6 text-orange-500">End User License Agreement (EULA)</h1>
      <p className="mb-4">Effective Date: 4/10/2025</p>
      
      <p className="mb-6">This End User License Agreement ("Agreement") is between you and Show Your Bits and governs your use of the Show Your Bits mobile application ("App"). By downloading or using the App, you agree to be bound by this Agreement.</p>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">1. License</h2>
        <p>You are granted a non-exclusive, non-transferable, revocable license to use the App for personal, non-commercial purposes strictly in accordance with this Agreement.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">2. Restrictions</h2>
        <p>You agree not to:</p>
        <ul className="list-disc ml-6 mt-2">
          <li>Reverse engineer, decompile, or modify the App.</li>
          <li>Use the App for any unlawful purpose or in violation of any applicable law or regulation.</li>
          <li>Rent, lease, or sublicense the App to others.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">3. Ownership</h2>
        <p>The App and all rights, title, and interest in and to the App, including all intellectual property rights, are owned by ShowYourBits.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">4. User-Generated Content</h2>
        <p>If the App allows you to submit content, you retain ownership of that content but grant us a non-exclusive, royalty-free license to use, display, and distribute it within the App and associated services.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">5. Termination</h2>
        <p>This license is effective until terminated. It will terminate automatically without notice if you fail to comply with any term. Upon termination, you must cease all use of the App and delete all copies.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">6. No Warranty</h2>
        <p>The App is provided "as is" and "as available" without warranty of any kind. We disclaim all warranties, including implied warranties of merchantability and fitness for a particular purpose.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">7. Limitation of Liability</h2>
        <p>To the fullest extent permitted by law, ShowYourBits will not be liable for any damages arising out of or relating to the use of or inability to use the App.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">8. Updates</h2>
        <p>We may provide updates that must be installed to continue using the App. You agree to accept such updates as part of this license.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">9. Governing Law</h2>
        <p>This Agreement is governed by the laws of The United States of America, excluding its conflicts of law principles.</p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-orange-500">10. Contact</h2>
        <p>If you have any questions about this Agreement, you can contact us at:</p>
        <p className="mt-2">Email: showyourbits@protonmail.com</p>
      </section>
    </div>
  );
}
